export const RECOMMENDATION_SOURCE = {
    DY: 'DY Strategy',
    GUSA: 'GUSA Strategy',
} as const;
